var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_225_19261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 5.18535L16.1293 9.05572L19.9997 12.9261M5.68486 3.3335L3.33301 5.68535L12.0923 14.4446H3.33301V25.5557H10.7404L19.9997 34.815V22.352L27.87 30.2409C26.6293 31.1853 25.2404 31.9631 23.7034 32.4076V36.2409C26.2589 35.6483 28.5737 34.4816 30.5182 32.889L34.3145 36.6668L36.6663 34.315L19.9997 17.6483M32.9626 20.0002C32.9626 21.7409 32.5923 23.3705 31.9626 24.889L34.7589 27.6853C35.9626 25.389 36.6663 22.7779 36.6663 20.0002C36.6663 12.0742 31.1108 5.44461 23.7034 3.75942V7.57424C29.0552 9.16683 32.9626 14.1298 32.9626 20.0002ZM28.333 20.0002C28.333 16.7224 26.4812 13.9076 23.7034 12.5372V16.6298L28.2404 21.1668C28.333 20.7965 28.333 20.3891 28.333 20.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_225_19261",
    x: 0.666341,
    y: 0.666829,
    width: 38.6663,
    height: 38.6668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_225_19261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_225_19261",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.41a5e8f4212d6f0c5316ca4e0d259e56.svg";
export { ForwardRef as ReactComponent };